<div class="branch-wrap">
    <div class="branch-box-wrap">
        <div class="branch-box" [ngClass]="{'is-conditional-node': isConditionalNode}">
            <div class="add-branch add-branch-small">
                <button class="btn branch-btn" type="button" (click)="node.addCondition($event)">
                    <smart-icon name="add-square" class="add-icon"></smart-icon>
                </button>
            </div>
            <ng-container *ngIf="node.branchs && node.branchs.length > 0">
                <div *ngFor="let branch of node.branchs; let i = index" class="col-box"
                    [ngClass]="{'is-conditional-node': isConditionalNode}" (click)="onClickEvent($event, branch)">
                    <div class="condition-node">
                        <ng-container *ngIf="i===0">
                            <div class="top-left-cover-line"></div>
                            <div class="bottom-left-cover-line"></div>
                        </ng-container>
                        <div class="condition-node-box" [ngClass]="{'is-conditional-node': isConditionalNode}">
                            <div class="condition-card-container" *ngIf="isBranchConditionCardVisible(branch)"
                                (click)="onConditionCardClicked($event, branch)">
                                <div class="condition-card" *ngIf="!branch.conditionDisplayLines">
                                    {{'workflow.always_pass_through_this_branch' | stringLiterals}}</div>
                                <div class="condition-card"
                                    [title]="getConditionArrayTooltip(branch.conditionDisplayLines)"
                                    *ngIf="branch.conditionDisplayLines && branch.conditionDisplayLines.length <= 2">
                                    <span *ngFor="let displayLine of branch.conditionDisplayLines"
                                        class="condition-line">
                                        <span class="condition-field-name">{{displayLine.field}}</span>&nbsp;
                                        <span class="condition-operator">{{displayLine.operator}}</span>&nbsp;
                                        <span class="condition-expected-value">{{displayLine.expectedValue}}</span>
                                    </span>
                                </div>
                                <!-- display ... in the second line if the amount of conditions is more than two -->
                                <div class="condition-card"
                                    [title]="getConditionArrayTooltip(branch.conditionDisplayLines)"
                                    *ngIf="branch.conditionDisplayLines && branch.conditionDisplayLines.length > 2">
                                    <span class="condition-line">
                                        <span
                                            class="condition-field-name">{{branch.conditionDisplayLines[0].field}}</span>&nbsp;
                                        <span
                                            class="condition-operator">{{branch.conditionDisplayLines[0].operator}}</span>&nbsp;
                                        <span
                                            class="condition-expected-value">{{branch.conditionDisplayLines[0].expectedValue}}</span>
                                    </span>
                                    <span class="condition-line">
                                        ...
                                    </span>
                                </div>
                            </div>
                            <ng-container *ngIf="branch.automationConfigs">
                                <tam-diagram-automation-render [automationConfigs]="branch.automationConfigs" [targetId]="branch.guid"></tam-diagram-automation-render>
                            </ng-container>
                            <div class="add-node-btn">
                                <div class="close-branch" (click)="onDeleteBranch($event, branch)">
                                    <smart-icon name="close"></smart-icon>
                                </div>
                                <button class="btn" type="button" (click)="node.addBranchChild($event, branch.guid, true)">
                                    <smart-icon name="add-square" class="add-icon"></smart-icon>
                                </button>
                            </div>
                        </div>
                        <ng-container *ngIf="i===node.branchs.length -1">
                            <div class="top-right-cover-line"></div>
                            <div class="bottom-right-cover-line"></div>
                        </ng-container>
                    </div>
                    <ng-container *ngIf="node.hasChildren()">
                        <tam-diagram-node *ngFor="let child of node.getConditionNodes(branch.guid)"
                            [branchId]="branch.guid" [nodeId]="child">
                        </tam-diagram-node>
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
    <ng-container *ngIf="node.automationConfigs">
        <tam-diagram-automation-render [automationConfigs]="node.automationConfigs" [targetId]="node.id"></tam-diagram-automation-render>
    </ng-container>
    <div class="add-node-btn-box">
        <div class="add-node-btn">
            <button class="btn" type="button" #addButton_3 (click)="node.addGatewaySuccessor($event)">
                <smart-icon name="add-square" class="add-icon"></smart-icon>
            </button>
        </div>
    </div>
    <ng-container *ngIf="node.hasChildren()">
        <tam-diagram-node *ngFor="let child of node.getGatewaySuccessors()" [nodeId]="child">
        </tam-diagram-node>
    </ng-container>
</div>